/** @format */

import { Button, Empty, Switch, Tooltip } from "antd";
import React from "react";
import styled from "styled-components";

/* ------------------------------------------------------------------ */
/* Filtri di visualizzazione                                          */
/* ------------------------------------------------------------------ */

interface ReportFiltersProps {
  hideEmptyRows: boolean;
  onHideEmptyRowsChange: (value: boolean) => void;
  onlyWithAnomalies: boolean;
  onOnlyWithAnomaliesChange: (value: boolean) => void;
  /** quanti dipendenti del report hanno almeno un giorno con anomalie */
  employeesWithAnomalies: number;
}

export const ReportFilters = ({
  hideEmptyRows,
  onHideEmptyRowsChange,
  onlyWithAnomalies,
  onOnlyWithAnomaliesChange,
  employeesWithAnomalies,
}: ReportFiltersProps): JSX.Element => {
  const noAnomalies = employeesWithAnomalies === 0;

  const anomaliesSwitch = (
    <FilterLabel className={noAnomalies ? "is-disabled" : undefined}>
      <Switch
        size="small"
        checked={onlyWithAnomalies && !noAnomalies}
        disabled={noAnomalies}
        onChange={onOnlyWithAnomaliesChange}
      />
      Solo dipendenti con anomalie
      <Count className={noAnomalies ? undefined : "has-anomalies"}>{employeesWithAnomalies}</Count>
    </FilterLabel>
  );

  return (
    <Filters>
      <FilterLabel>
        <Switch size="small" checked={hideEmptyRows} onChange={onHideEmptyRowsChange} />
        Nascondi righe a zero
      </FilterLabel>

      {noAnomalies ? (
        <Tooltip title="Nessuna anomalia nel periodo con le impostazioni scelte per il report">
          {anomaliesSwitch}
        </Tooltip>
      ) : (
        anomaliesSwitch
      )}
    </Filters>
  );
};

/* ------------------------------------------------------------------ */
/* Nessun dipendente dopo ricerca e filtri                            */
/* ------------------------------------------------------------------ */

interface ReportEmptyResultProps {
  onReset: () => void;
}

export const ReportEmptyResult = ({ onReset }: ReportEmptyResultProps): JSX.Element => (
  <EmptyWrap>
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Nessun dipendente corrisponde alla ricerca e ai filtri attivi"
    >
      <Button onClick={onReset}>Mostra tutti i dipendenti</Button>
    </Empty>
  </EmptyWrap>
);

/* ------------------------------------------------------------------ */
/* Stili                                                              */
/* ------------------------------------------------------------------ */

const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
`;

const FilterLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  &.is-disabled {
    cursor: not-allowed;
    color: #8c8c8c;
  }
`;

const Count = styled.span`
  min-width: 22px;
  padding: 0 7px;
  border-radius: 10px;
  background: #f0f0f0;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;

  &.has-anomalies {
    background: #fff1f0;
    color: #cf1322;
  }
`;

const EmptyWrap = styled.div`
  padding: 40px 0;
  border: 1px dashed #e8e8e8;
  border-radius: 8px;
`;
